import * as React from 'react';
import { Typography, Button, Stack, useTheme } from '@mui/material';
import BackButton from '../../../components/BackButton';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useState } from 'react';
import { useAuthContext } from '../../../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import BgBoxOld from '../../../components/BgBoxOld';
import { useEffect } from 'react';
import { getProjDDByComServ } from '../../../services/proj-service';
import CustomDropDown from '../../../components/CustomDropDown';
import { isNotEmpty } from '../../../utils/format';
import QueryKey from '../../../utils/QueryKey';
import { useQuery } from 'react-query';
import { assignProjSourceUserServ } from '../../../services/source-service';
import { getAllComDDServ } from '../../../services/com-service';





function AssignSourceEmpPage() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { userId, empName, username } = location.state || {};
  const { setLoadingScreen } = useAuthContext();
  const [formErrors, setFormErrors] = useState({});
  const txtFieldSx = { width: 300, height: 30, borderRadius: 1 }
  const [selection, setSelection] = useState({ comId: "", projIdStrg: "" });
  const { isLoading: isComLoading, isError: isComErr, error: comErr, data: comData } = useQuery([QueryKey.comListDD], () => getAllComDDServ(),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: false,
    })
  const { isLoading, isError, error, data: projData } = useQuery([QueryKey.projListDD, selection.comId], () => getProjDDByComServ({ comId: selection.comId }),
    {
      enabled: isNotEmpty(selection.comId),
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: false,
    })

  useEffect(() => {
    setLoadingScreen(isComLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isComLoading]);

  useEffect(() => {
    setLoadingScreen(isLoading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  useEffect(() => {
    if (!userId)
      navigate("/", { replace: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])




  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
    let errorsObj = validate(inputObject);
    setFormErrors(errorsObj);
    if (Object.keys(errorsObj).length > 0)
      return;

    setLoadingScreen(true);
    try {
      const payload = {
        userId,
        comId: isNotEmpty(selection.comId) ? selection.comId : null,
        projIdStrg: isNotEmpty(selection.projIdStrg) ? selection.projIdStrg : null,

      }
      const { message } = await assignProjSourceUserServ(payload);
      notify("success", message);
      navigate(`${route.aAmtcEmpInfo}/?userId=${userId}`, { replace: true })
    } catch (error) {
      console.log(error)
      customAlert(error)
    }
    setLoadingScreen(false);
  };

  function validate(values) {
    const errors = {};

    if (!values.comId)
      errors.comId = "Company is required!";
    if (!values.projIdStrg)
      errors.projIdStrg = "Project is required!";

    return errors;
  };

  function handleDDChange(e) {
    const { name, value } = e.target;
    
    setSelection((e) => { return { ...e, [name]: value } });
  }

  if (isComErr) {
    customAlert(comErr);
    return <h2>Something went wrong</h2>
  }

  if (isError) {
    customAlert(error);
    return <h2>Something went wrong</h2>
  }

  return (<form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
    <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
      <Stack width={"20%"}>
        <BackButton />
      </Stack>
      <Stack width={"60%"} alignItems={"center"}>
        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Assign Source Employee </Typography>
      </Stack>
      <Stack width={"20%"} />
    </Stack>
    <BgBoxOld height={"93%"} py={1}>
      <Stack direction={"row"} height={"100%"} gap={6} mt={1} >
        <Stack sx={{ width: "30%", height: "90%" }} gap={2}>
          <LabelTxtFieldInfo defaultValue={empName} name="empName" title="Employee Name" {...txtFieldSx}
            bgColor={"rgba(162, 214, 249, 0.18)"} readOnly={true} />
          <LabelTxtFieldInfo defaultValue={username} name="username" title="Email ID (Username)" {...txtFieldSx}
            bgColor={"rgba(162, 214, 249, 0.18)"} readOnly={true} />
          <CustomDropDown name="comId" title={"Company *"} errMsg={formErrors.comId} {...txtFieldSx} handleDDChange={handleDDChange} ddArr={comData || []} />
          <CustomDropDown name="projIdStrg" title={"Project *"} errMsg={formErrors.projIdStrg}  {...txtFieldSx} handleDDChange={handleDDChange} ddArr={projData?.projArr || []} />
          <Stack width={"100%"} alignItems={"end"}>
            <Button variant="contained" type="submit"
              sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>ASSIGN</Button>
          </Stack>
        </Stack>
      </Stack>
    </BgBoxOld>
  </form>
  );
}

export default AssignSourceEmpPage;